import React from "react";

/**
 * Tag neutre — client à risque / dormant / panier en baisse.
 * Aligné sur le thème "sobre premium" (casse normale, pill neutre).
 */
const CONFIG = {
  A_RISQUE:  { label: "Client à risque" },
  DORMANT:   { label: "Client dormant" },
  EN_BAISSE: { label: "Panier en baisse" },
};

export default function ClientTag({ tag, testid }) {
  if (!tag) return null;
  const c = CONFIG[tag];
  if (!c) return null;
  return (
    <span
      data-testid={testid || `client-tag-${tag.toLowerCase()}`}
      className="th-pill th-pill--neutral"
    >
      {c.label}
    </span>
  );
}
